module.exports = __webpack_public_path__ + "static/img/qqbxc_face.305e453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/qqbxc_face.png
// module id = fOPd
// module chunks = 0